import React from "react";

import { ReactComponent as SearchIcon } from "../../build/images/icons/search02.svg";

import "./input-search.css";

const defaultHandleClick = () => {};

function InputSearch({
  search,
  setSearch,
  handleClick = defaultHandleClick,
  placeholder,
  onSearch,
  icon,
  onKeyDown,
  exibIcon = true,
}) {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch(event);
    }
  };

  return (
    <div className="inputSearchOpts__input inputSearchOptsInput">
      <input
        className="inputSearchOptsInput__input"
        type="text"
        placeholder={placeholder ? placeholder : "Pesquisar"}
        value={search}
        onChange={({ target }) => {
          setSearch(target.value);
        }}
        onKeyDown={onKeyDown ? handleKeyDown : null}
      />
      {exibIcon && (
        <button className="inputSearchOptsInput__btn" onClick={onSearch}>
          {icon ? icon : <SearchIcon />}
        </button>
      )}
    </div>
  );
}

export default InputSearch;
